import { fmtBRL } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, PieChart, Pie, Legend } from "recharts";
import { MapPin } from "lucide-react";

const COLORS = ["#EA580C", "#F59E0B", "#3B82F6", "#10B981", "#F43F5E", "#8B5CF6", "#14B8A6", "#F97316"];

// Gráficos do Dashboard: top entregadores, regiões (pizza) e bairros (barras horizontais).
export function DashboardCharts({ s, canSeeFinanceiro }) {
  // `total` monetário só aparece no tooltip para quem tem financeiro.v
  const moneyTip = (v, n) => (canSeeFinanceiro && n === "total") ? fmtBRL(v) : (n === "total" ? "" : v);
  const regioes = s.per_regiao.slice(0, 6);
  return (
    <>
      <div className="grid md:grid-cols-2 gap-4 md:gap-6">
        <Card><CardHeader><CardTitle>Top Entregadores</CardTitle></CardHeader>
          <CardContent style={{ height: 300 }} className="min-w-0">
            <ResponsiveContainer width="99%" height="100%"><BarChart data={s.per_entregador.slice(0, 8)}>
              <XAxis dataKey="entregador" fontSize={11}/><YAxis fontSize={11}/>
              <Tooltip formatter={moneyTip}/>
              <Bar dataKey="count" fill="#EA580C" radius={[6, 6, 0, 0]}/>
            </BarChart></ResponsiveContainer>
          </CardContent>
        </Card>
        <Card><CardHeader><CardTitle>Regiões Mais Entregues</CardTitle></CardHeader>
          <CardContent style={{ height: 300 }} className="min-w-0">
            <ResponsiveContainer width="99%" height="100%"><PieChart>
              <Pie data={regioes} dataKey="count" nameKey="regiao" outerRadius={100} label>
                {regioes.map((row, i) => <Cell key={row.regiao || i} fill={COLORS[i % COLORS.length]}/>)}
              </Pie><Legend/><Tooltip/>
            </PieChart></ResponsiveContainer>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="flex items-center gap-2"><MapPin className="w-5 h-5 text-orange-600"/>Bairros com Mais Entregas</CardTitle>
          <span className="text-xs text-muted-foreground">Top 15</span>
        </CardHeader>
        <CardContent style={{ height: 380 }} className="min-w-0">
          {s.per_bairro && s.per_bairro.length > 0 ? (
            <ResponsiveContainer width="99%" height="100%">
              <BarChart data={s.per_bairro} layout="vertical" margin={{ left: 90 }}>
                <XAxis type="number" fontSize={11}/>
                <YAxis type="category" dataKey="bairro" fontSize={11} width={120}/>
                <Tooltip formatter={moneyTip}/>
                <Bar dataKey="count" fill="#F59E0B" radius={[0, 6, 6, 0]}/>
              </BarChart>
            </ResponsiveContainer>
          ) : <div className="text-center text-muted-foreground py-12">Sem dados de bairros</div>}
        </CardContent>
      </Card>
    </>
  );
}
